function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Keyboard, Animated } from 'react-native';
import * as R from 'unitx/ramda';
import { Machine, actions } from 'unitx/xstate';
import useForwardRef from "../../hooks/useForwardRef";
import useMachine from "../../hooks/useMachine";
import wrapComponent from "../../core/wrapComponent";
import { Text, Button, View } from "../native";
import { useTheme } from "../../theme"; // const PLATFORM = {
//   IOS: 'ios',
//   ANDROID: 'android',
//   WEB: 'web',
// }

const POSITION = {
  ABSOLUTE: 'absolute',
  BOTTOM: 'bottom',
  TOP: 'top'
};
const stateMachine = Machine({
  id: 'toast',
  initial: 'closed',
  context: {
    fadeAnim: new Animated.Value(0),
    keyboardHeight: 0,
    isKeyboardVisible: false,
    modalVisible: false,
    text: '',
    title: '',
    color: 'primary',
    position: POSITION.BOTTOM,
    options: [],
    onClose: R.identity
  },
  states: {
    showed: {
      onEntry: ['showToast'],
      onExit: ['closeToast'],
      after: {
        TOAST_DURATION: 'closed'
      },
      on: {
        CLOSE_TOAST: 'closed'
      }
    },
    closed: {
      on: {
        SHOW_TOAST: {
          dataType: null,
          target: 'showed'
        }
      }
    }
  },
  on: {
    KEYBOARD_SHOWED: {
      dataType: {
        keyboardHeight: 1
      },
      actions: ['keyboardShowed']
    },
    KEYBOARD_HIDDEN: {
      actions: ['keyboardHidden']
    }
  }
});

const ToastContainerElement = (props, forwardedRef) => {
  var _theme$colors$color;

  const theme = useTheme();
  const {
    current,
    sender
  } = useMachine(stateMachine, {
    delays: {
      TOAST_DURATION: (__, {
        data: {
          duration
        }
      }) => duration !== null && duration !== void 0 ? duration : 1500
    },
    actions: {
      showToast: actions.assign((context, _ref) => {
        let {
          data: {
            duration
          }
        } = _ref,
            rest = _objectWithoutProperties(_ref.data, ["duration"]);

        return R.pipe(R.tap(() => Animated.timing(context.fadeAnim, {
          toValue: 1,
          duration: 200,
          useNativeDriver: true
        }).start()), R.always(_objectSpread({
          modalVisible: true,
          duration
        }, rest)))(duration);
      }),
      closeToast: actions.assign(context => R.pipe(R.always(Animated.timing(context.fadeAnim, {
        toValue: 0,
        duration: 200,
        useNativeDriver: true
      }).start()), R.defaultTo(() => {})(context.onClose), R.always({
        modalVisible: false
      }))(context)),
      keyboardShowed: actions.assign({
        keyboardHeight: (context, {
          data
        }) => data.keyboardHeight,
        isKeyboardVisible: true
      }),
      keyboardHidden: () => actions.assign({
        keyboardHeight: 0,
        isKeyboardVisible: false
      })
    }
  });
  React.useEffect(() => {
    Keyboard.addListener('keyboardDidShow', e => sender.KEYBOARD_SHOWED({
      keyboardHeight: e.endCoordinates.height
    }));
    Keyboard.addListener('keyboardDidHide', // @ts-ignore
    () => sender.KEYBOARD_HIDDEN());
  }, []);
  useForwardRef(forwardedRef, {}, () => ({
    show: config => sender.closed.SHOW_TOAST(config),
    close: () => sender.showed.CLOSE_TOAST()
  }));
  /* eslint-enable functional/immutable-data, functional/no-expression-statement */

  const {
    text,
    color,
    options,
    title,
    modalVisible
  } = current.context; // @ts-ignore

  const backgroundColor = (_theme$colors$color = theme.colors[color]) !== null && _theme$colors$color !== void 0 ? _theme$colors$color : color;
  return R.ifElse(R.always(modalVisible), R.always( /*#__PURE__*/React.createElement(Animated.View, {
    style: {
      width: '100%',
      height: title ? '9%' : '6.5%',
      bottom: 0,
      position: 'absolute'
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: '100%',
      height: '100%',
      backgroundColor,
      padding: 5,
      justifyContent: 'center'
    }
  }, title ? /*#__PURE__*/React.createElement(Text, {
    category: "s1"
  }, title) : null, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor,
      padding: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      flex: 1
    }
  }, text), R.isNonEmptyArray(options) && /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 0.1 * options.length,
      backgroundColor,
      flexDirection: 'row'
    }
  }, R.map(({
    text: buttonText,
    onPress,
    color
  }) => /*#__PURE__*/React.createElement(Button, {
    style: {
      flex: 1,
      margin: 3
    },
    status: color,
    appearance: "outline",
    onPress: onPress
  }, buttonText))(options)))))), R.always(null))();
};

export const ToastContainer = wrapComponent(ToastContainerElement, {
  isForwardRef: true
});
const Toast = {
  instance: {
    show: c => c,
    close: () => {}
  },
  show: c => Toast.instance.show(c),
  close: () => Toast.instance.close(),
  ALWAYS: 100000,
  // @ts-ignore
  setInstance: instance => {
    Toast.instance = instance;
  }
};
export default Toast;